import getConfig from "next/config";
import Link from "next/link";
import { getSlug } from "@lib/helpers";

import Heading from "@components/Heading";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const CategoryCard = ({ category }) => {
  const linkTarget = category.use_anchors
    ? `#${getSlug(`gama-produse-${category.slug}`)}`
    : category.url;

  return (
    <>
      <Link href={linkTarget}>
        <a title={category.name} className="py-[30px] px-[20px]">
          {category.image && (
            <img
              src={`${settings.cdn}${category.image}`}
              alt={category.seo.title || category.name}
            />
          )}
        </a>
      </Link>

      {category.name && (
        <Heading
          as="h2"
          title={
            <Link href={linkTarget}>
              <a title={category.name}>{category.name}</a>
            </Link>
          }
          classesProp="text-[20px] md:text-[22px] leading-[20px] md:leading-[28px] -tracking-[0.28px] text-center"
        />
      )}
    </>
  );
};

export default CategoryCard;
